import aliciaPic from "@/public/images/artists/alicia.jpg";
import { Artist } from "@/types/types";

export const alicia = {
  id: "205",
  name: "Alicia",
  image: aliciaPic,
  description: `Alicia's voice carries a bright, clear timbre that reflects her youth, and she can belt out powerful notes when a song calls for it.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Falicia-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Kids", "Unprocessed", "Dance", "Theatrical", "Ballads", "Pop"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 58,
        high: 76,
      },
      sweetSpot: 66,
    },
  },
} as const satisfies Artist;
